import type { TranslationKey } from "../locales";
import type { Tables } from "../types";

/**
 * This function returns the translation key associated with a given project state.
 * @param state
 * @returns
 */
export function getProjectStateString(state: Tables<"projects">["state"]): TranslationKey {
	switch (state) {
		case "active":
			return "projects.state.active";
		case "inactive":
			return "projects.state.inactive";
		case "archived":
			return "projects.state.archived";
		default:
			return "projects.state.archived";
	}
}
